import React, { Component } from 'react';
import Entry from './entries/Entry';
import Hours from './time/Hours';
import Now from './time/Now';
import { ENTRY_WIDTH_UNIT } from '../../../constants/styling/styles';

class Body extends Component {
    state = { hoveredEntryStart: null, hoveredEntryEnd: null };

    componentDidMount() {
        this.timerId = setInterval(this.props.updateNow, 60000);
    }
    componentWillUnmount() {
        clearInterval(this.timerId);
    }
    _nowNotOnScreen = (nowOffset) => {
        const delta = nowOffset - this.props.scrollX;
        return delta < 0 || delta > window.innerWidth;
    };
    _handleEntryHover = (startHour, endHour) => {
        this.setState({ hoveredEntryStart: startHour, hoveredEntryEnd: endHour });
    };
    _handleEntryLeave = () => {
        this.setState({ hoveredEntryStart: null, hoveredEntryEnd: null });
    };
    render() {
        return (
            <div className="ckp-timetable-body">
                <Now offset={this.props.nowOffset} />
                <Hours
                    zoom={this.props.zoom}
                    nowOnClick={this.props.goToNow}
                    nowButton={this.props.showNow && this._nowNotOnScreen(this.props.nowOffset)}
                    hours={this.props.hours}
                    marginLeft={-this.props.scrollX}
                    minHour={this.props.minHour}
                    hoveredEntryStart={this.state.hoveredEntryStart}
                    hoveredEntryEnd={this.state.hoveredEntryEnd}
                />
                {this.props.stages.map((stage, i) => [
                    <div
                        key={stage.id}
                        className="ckp-timetable-row"
                        style={{ width: (this.props.hours.length / 2) * (ENTRY_WIDTH_UNIT * this.props.zoom) }}
                    >
                        <h2 className="ckp-timetable-stage">
                            <span className="ckp-timetable-stage-name ckp-ts-h4">{stage.name}</span>
                        </h2>
                        <ul className="ckp-timetable-entries">
                            {stage.Performances.map((entry) => (
                                <Entry
                                    favOrUnfavArtist={this.props.favOrUnfavArtist}
                                    favoriteArtists={this.props.favoriteArtists}
                                    zoom={this.props.zoom}
                                    isLiveView={this.props.isLiveView}
                                    artistsFilters={this.props.artistsFilters}
                                    categoryFilters={this.props.categoryFilters}
                                    selectedPartner={this.props.selectedPartner}
                                    day={this.props.day}
                                    stage={stage.name}
                                    onClick={this.props.showEntry}
                                    key={entry.id}
                                    minHour={this.props.minHour}
                                    entry={entry}
                                    onEntryHover={this._handleEntryHover}
                                    onEntryLeave={this._handleEntryLeave}
                                />
                            ))}
                        </ul>
                    </div>
                ])}
            </div>
        );
    }
}

export default Body;
